import PropTypes from 'prop-types';

import styles from './SearchOption.scss';

const SearchOption = (props) => {
  const { children } = props;

  return (
    <div className={styles.root}>
      {children}
    </div>
  );
};

SearchOption.propTypes = {
  children: PropTypes.node,
};

export default SearchOption;
